export const DOOR_STYLE_COLLECTIONS = [
  'Classic',
  'Contemporary',
  'Country Cottage',
  'Heritage',
] as const;

export type DoorStyleCollection = (typeof DOOR_STYLE_COLLECTIONS)[number];

export function isDoorStyleCollection(value: string | null | undefined): value is DoorStyleCollection {
  return DOOR_STYLE_COLLECTIONS.includes(value as DoorStyleCollection);
}
